import {
  TaxDocumentCardLink,
  TaxDocumentConfig,
} from "../tax-info/TaxInfoForm/tax-info-config";
import { useGetEorDocumentLazyQuery } from "types/generated/operations";

const useGetEorDocument = () => {
  const [getEorDocument] = useGetEorDocumentLazyQuery();

  const fetchSingleS3Link = async (s3ReferenceKey: string) => {
    const result = await getEorDocument({
      variables: { fileId: s3ReferenceKey },
    });
    return result.data?.eorDocument?.signedUrl;
  };

  const updateSingleCardLink = async (link: TaxDocumentCardLink) => {
    if (!link.s3ReferenceKey) return link;
    const result = await fetchSingleS3Link(link.s3ReferenceKey);
    return {
      ...link,
      linkUrl: result,
    };
  };

  const fetchAndUpdateS3Links = async (taxInfoConfig: TaxDocumentConfig[]) => {
    const updatedConfig = await Promise.all(
      taxInfoConfig.map(async (taxDocumentConfig: TaxDocumentConfig) => {
        const updatedLinks = await Promise.all(
          taxDocumentConfig.cardDescriptionLinks?.map(updateSingleCardLink) ??
            []
        );

        return { ...taxDocumentConfig, cardDescriptionLinks: updatedLinks };
      })
    );
    return updatedConfig;
  };
  return { fetchAndUpdateS3Links };
};

export default useGetEorDocument;
